"use client";

import { useActionState } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { registerAgent } from "@/lib/actions";
import { Field, SubmitButton, ErrorNote } from "@/components/AuthShell";

export function RegisterForm() {
  const [state, action, pending] = useActionState(registerAgent, undefined);
  const searchParams = useSearchParams();
  const urlError = searchParams.get("error");

  return (
    <>
      <form action={action} className="space-y-4">
        <ErrorNote error={urlError ?? state?.error} />
        <Field label="Full name" name="name" placeholder="Alex Rivera" />
        <Field label="Email" name="email" type="email" placeholder="you@brokerage.com" />
        <Field
          label="Brokerage (optional)"
          name="brokerage"
          placeholder="Rivera Realty Group"
          required={false}
        />
        <Field label="Password (8+ characters)" name="password" type="password" />
        <SubmitButton pending={pending}>Create account</SubmitButton>
      </form>
      <p className="mt-4 text-center text-sm text-slate-500">
        Already have an account?{" "}
        <Link href="/login" className="font-medium text-emerald-700 hover:underline">
          Log in
        </Link>
      </p>
    </>
  );
}
